var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.context.connection_type == 1)?[_vm._v(" "+_vm._s(_vm.context.account_number)+" ")]:[_c('ul',{staticClass:"pl-2"},_vm._l((_vm.context.schema_config.split(',')),function(cr){return _c('li',[_vm._v(_vm._s(cr))])}),0)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }